export default __webpack_public_path__ + "static/media/correctIcon.47c15f23.svg";